import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { Store } from '@ngrx/store';
import { CoinComponent } from '@pt/components';
import { Balance } from '@pt/models';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule, IconModule } from '@hglobal/common';
import { environment } from '@pt/environment';
import { ImageLoaderDirective } from '@pt/directives';

import { BalanceActions } from '../../store';

@Component({
  imports: [TranslateModule, IconModule, ButtonModule, ImageLoaderDirective, CoinComponent],
  selector: 'pu-balance-card',
  templateUrl: './balance-card.component.html',
  styleUrls: ['./balance-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BalanceCardComponent {
  balance = input<Balance>();

  assetsHost = environment.assetsHost;

  private _store = inject(Store);

  edit(balance: Balance) {
    this._store.dispatch(BalanceActions.getBalanceSkinsReq.action({ initiator: balance }));
  }
}
